import React from "react";

const BASE_WIDTH = 4;
const BASE_HEIGHT = 4;

export default function BulletIcon(props: {
  height?: number;
  width?: number;
  color?: string;
}) {
  const width = props.width || BASE_WIDTH;
  const height = props.height || BASE_HEIGHT;

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="2" cy="2" r="2" fill={props.color ?? "#4D4D4D"} />
    </svg>
  );
}
